var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.94 49.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #8a397e;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.18,18.31l-17.25,4.29c-1.7-1.94-4.44-2.83-7.11-1.99-3.08.97-5.08,4.09-4.65,7.29.54,4.05,4.45,6.63,8.31,5.67,2.54-.63,4.37-2.62,4.93-5l4-1,1.14-1.92.05-.03,2.18,1.11,1.61-2.15,2.58,1.11,1.79-2.27,2.7,1.15h0l2.7-3.56c.47-.62.32-1.5-.33-1.94l-.62-.41c-.6-.4-1.33-.53-2.03-.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.95,27.12c-.97,9.15-7.28,17.28-16.65,20.12-9.24,2.8-18.86-.34-24.78-7.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.99,21.77C2.09,12.77,8.36,4.82,17.6,2.02c9.37-2.84,19.13.42,25.02,7.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.51 44.49 5.35 38.69 11.08 39.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "43.25 4.65 43.42 10.46 37.69 9.91"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.18,
    y: 38.77,
    width: 1.1,
    height: 2.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordPurple);
export default __webpack_public_path__ + "static/media/password-purple.9d2d2d29eb6bcbf891f1bb30ce24e026.svg";
export { ForwardRef as ReactComponent };